import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

// * Styling for the Blade menu is inside of src/themes/bladeStyles

import closeImg from '../../../images/closeicon_dark.svg';

export const Wrapper = styled.div`
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
`;

export const Header = styled.div`
  width: 100%;
  outline: none;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  padding: 15px 30px 15px;
`;

export const Overlay = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3) none repeat scroll 0% 0%;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  transition: opacity 0.3s ease 0s;
  transition: ${({ isOpen }) =>
    isOpen
      ? 'opacity 0.3s ease 0s'
      : 'opacity 0.3s ease 0s, transform 0s ease 0.3s'};
  transform: ${({ isOpen }) => (isOpen ? '' : 'translate3d(100%, 0px, 0px)')};
  top: 0px;
  left: 0px;
  right: 0px;

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    background: rgba(0, 0, 0, 0) none repeat scroll 0% 0%;
  }
`;

export const Body = styled.div`
  display: flex !important;
  flex-direction: column;
  outline: none;

  padding: 0 30px 50px;

  height: 90vh;
`;

export const Logo = styled.img`
  height: 31px;

  @media only screen and (min-width: ${themeGet('breakpoints.ml')}) {
    height: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 116px;
    margin-right: 50px;
  }
`;

export const CloseBtn = styled.button.attrs(() => ({
  type: 'button',
}))`
  font-size: 16px;
  letter-spacing: -0.06px;
  display: flex;
  align-items: center;
  color: transparent;

  &::after {
    content: '';
    display: block;
    height: 21px;
    width: 21px;
    margin-left: 1rem;
    background-image: url(${closeImg});
    background-repeat: no-repeat;
    background-size: contain;
  }

  @media only screen and (min-width: 679px) {
    color: ${themeGet('colors.red', 'red')};
  }
`;
